import React, {useState} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import {Box, Checkbox, FormControlLabel, FormGroup, Typography} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {Alert} from "@material-ui/lab";
import {useConsumerContext} from "../../context/ConsumerContext";
import {AVAILABLE_ACTIONS} from "../../utils/constants";

export default function WelcomePage() {
    // context from parent
    const {consumerData, dispatch} = useConsumerContext();

    const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [acceptTC, setAcceptTC] = useState(false);

    const onChange = (value) => {
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_CONTACTINFO, userRequest: {"grecaptcha": value}});
        setIsCaptchaVerified(true);
    };

    const onExpired = () => {
        dispatch({type: AVAILABLE_ACTIONS.UPDATE_CONTACTINFO, userRequest: {"grecaptcha": null}});
        setIsCaptchaVerified(false);
    }

    const moveNext = () => {
        if (isCaptchaVerified && acceptTC) {
            setHasError(false);
            dispatch({type: AVAILABLE_ACTIONS.MOVE_NEXT, wizardStep: consumerData.wizardStep + 1});
        } else {
            setHasError(true);
        }
    }

    return (
        <Box m={3}>
            <Typography variant="h5" gutterBottom align="left">
                Consumer Agreement
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Welcome to the User Agreement (or "agreement") for the Florida Market Assistance Plan (FMAP). This
                Agreement describes the terms and conditions applicable to your use of FMAP services (the "site"). You
                must read, agree with and accept all the terms and conditions contained in this agreement, which
                include those expressly set out below and those incorporated by reference. We may amend this agreement
                at any time by posting the amended terms on this site, and all amended terms will be effective
                immediately.<br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                Eligibility
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Our services are available only to and may only be used by individuals who can form legally binding
                contracts under applicable law. Our services are not available to any person under the age of 18 or to
                temporarily or indefinitely suspended FMAP members. Your FMAP account/user ID may not be transferred to
                another party or shared with any other individual. If you are registering as a business entity, you are
                representing the authority to bind the entity to this agreement. <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                Fees and Services
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                The FMAP referral program is free and designed to match consumers who cannot find property insurance
                with Florida licensed agents and insurers who are writing property and casualty lines of business
                excluding workers' compensation, employer's liability, malpractice and motor vehicle
                coverage. <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                Privacy
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                We use your personal information to facilitate the services you request, matching property quote
                requests with agents and insurance companies that may be able to offer coverage. The information you
                provide will be made available to Florida licensed agents and insurance companies participating in FMAP
                solely for the purpose of offering you insurance coverage. All agents and insurance companies
                participating in the plan have certified to the above and are legally bound to only use the information
                you provide for this reason.

                We do not sell or rent your personal information to third parties for their marketing purposes without
                your explicit consent. We protect your information as described in the "Security" section of this
                agreement.

                FMAP may use personal information about you to improve marketing and promotional efforts, analyze site
                usage, improve content and product offerings, and customize the site's services to provide you with a
                smooth, efficient, safe and customized experience using the site.

                You agree that we may use your personal information to contact you and deliver the information you
                requested. By accepting this agreement, you expressly agree to receive this information. <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                General
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                This agreement is governed in all respects by the Florida law, as such laws are applied
                to agreements entered and to be performed entirely within Florida between Florida residents. We do not
                guarantee continuous, uninterrupted, or secure access to our services, and operation of the site may be
                interfered with by numerous factors outside of our control. If any provision of this agreement is found
                invalid or unenforceable, such provision will be struck and the remaining provisions will be enforced.

                FMAP retains the right to refuse service on or terminate a user account at any point if the program is
                being used improperly (i.e., false information is provided). <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                Security
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                Citizens Property Insurance Corporation uses physical, technical and administrative safeguards based on
                industry-standard practices to protect your private, personal information against loss, theft,
                unauthorized access and disclosure. <br/><br/>
            </Typography>

            <Typography variant="h5" gutterBottom align="left">
                Cookies
            </Typography>
            <Typography variant="string" gutterBottom align="left">
                We use cookies to enhance the website experience and improve services and functionality. By continuing to
                browse the site, you consent to the use of cookies and agree to our&nbsp;
                <a target="_blank" href="https://www.fmap.org/privacy-policy">Privacy Policy</a> and&nbsp;
                <a target="_blank" href="https://www.fmap.org/terms-and-conditions">Terms and Conditions</a>.<br/><br/>
            </Typography>

            <br/>
            <FormGroup>

                <FormControlLabel control={<Checkbox color="primary"  checked={acceptTC} onChange={(event) => {
                    setAcceptTC(event.target.checked);
                }}/>} label="I agree to the terms stated above."/>
            </FormGroup>
            <br/>
            <ReCAPTCHA onExpired={onExpired}
                sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_KEY}
                onChange={onChange}
            /> <br/>

            <Box component="span" justifyContent="flex-start" alignItems="flex-start" display="flex">
                <br/>
                <Button type="submit" variant="contained" color="primary" name="btnNext" onClick={moveNext}>
                    Next
                </Button>
            </Box><br/>

            {hasError && <div>
                <br/>
                <Alert variant="filled" severity="error">You must accept Consumer Agreement before continuing.</Alert>
            </div>}
        </Box>
    );
}
